import React from 'react';
import { ItemShimmer } from './ItemShimmer';
import { StyledPoiList } from '../PoiList';

interface IShimmerFlightListProps {
	listLength: number;
}

export const PoiListShimmer = ({ listLength }: IShimmerFlightListProps) => {
	const items = new Array(listLength).fill('');

	return (
		<>
			<StyledPoiList>
				{items.map((_, i) => (
					// eslint-disable-next-line react/no-array-index-key
					<ItemShimmer key={`shimmer-${i}`} />
				))}
			</StyledPoiList>
		</>
	);
};
